// extracted by mini-css-extract-plugin
export default {"loadingSpinnerContainer":"LoadingSpinner_loadingSpinnerContainer__ADBY1","spinner":"LoadingSpinner_spinner__Q1vlO","spin":"LoadingSpinner_spin__01Hjx"};